/**
 * Created by Christof Sander on 12.09.2016.
 */

module.exports = {
	model: {
		active: false
	},
	
	events: {
		changeActive: {
			type: 'change',
			selector: 'input[type="checkbox"]',
			action: function(event){
				var self = event.data.component;
				event.stopImmediatePropagation();
				self.onChange(undefined, event.target.checked);
			}
		}
	},

	methods: {
		onChange: function(value, active){
			var self = this;
			this.model.active = !!active;
			this.model.dataDATE = value || this.model.dataDATE;

			this.parent(function(parentComponent){
				parentComponent.trigger('onChildChanged', {
					fieldCode:  self.model.fieldCode,
					value:      self.model.active ? this.model.dataDATE : null
				});
			});
		}
	},

	hooks: {
		attach: function($element, options){
			if(!options.refresh){
				var self = this;
				this.find('base_form_fields_dateSelectSeparated', function(dateComponent){
					self.model.dataDATE = dateComponent.model.dataDATE;
				});
			}
		},

		onChildChanged: function($element, options){
			if(options.fieldCode == this.model.fieldCode){
				$element.find('input[type="checkbox"]').prop('checked', true);
				this.onChange(options.value, true);
			}
		}
	}
};
